
import { Component } from 'vue-property-decorator';
import VueApp from '@/@types/app/VueApp';

@Component
export default class Banner extends VueApp {}
